export default __webpack_public_path__ + "static/ringType1-edcf954429be425304a1546dc3907871.png";